{
  "mt-MT": {
    "model": {
      "profile": {
        "id": "ID tal-Utent",
        "userName": "Isem tal-utent",
        "email": "Indirizz tal-email",
        "emailConfirmed": "L-indirizz elettroniku ġie kkonfermat.",
        "phoneNumber": "Numru tat-telefon",
        "phoneNumberConfirmed": "In-numru tat-telefon ġie kkonfermat.",
        "twoFactorEnabled": "L-awtentikazzjoni b’żewġ fatturi attivata",
        "lockoutEnd": "Data tat-tmiem tal-lockout",
        "lockoutEnabled": "Il-funzjoni tal-illokkjar hija attivata.",
        "accessFailedCount": "In-numru ta' fallimenti ta' aċċess",
        "firstName": "Isem",
        "lastName": "Kunjom",
        "picture": "Ritratt tal-avatar",
        "organisationName": "Organizzazzjoni",
        "name": "Isem",
        "roles": "Ruoli"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Konfermat"
      },
      "action": {
        "resetPassword.tooltip": "Ibgħat l-istruzzjonijiet biex jerġa jaġġorna l-password lill-utent permezz tal-email."
      },
      "message": {
        "resetPassword.success": "Intbagħtet email lill-utent bil-istruzzjonijiet biex jirrisettja l-password tiegħu."
      }
    }
  }
}